import { assertNumber } from "../../../helper_functions/utils";

interface PurchaseOrderTotalLineItem {
  quantity: number | string;
  cost: number | string;
  received: number | string;
}

interface PurchaseOrderTotal {
  quantity: number;
  cost: number;
  totalCost: number;
  duties: number;
  received: number;
  receivedCost: number;
}

interface CostAndMarginLineItem {
  cost: number | string;
  price: number | string;
}

interface CostAndMargin {
  convertedCost?: number;
  margin: string;
}

export const getTotal = (
  quantities: Record<number, PurchaseOrderTotalLineItem>,
): PurchaseOrderTotal =>
  Object.values(quantities).reduce<PurchaseOrderTotal>(
    (acc, poli) => {
      acc.totalCost += assertNumber(poli.quantity) * assertNumber(poli.cost);
      acc.receivedCost += assertNumber(poli.received) * assertNumber(poli.cost);
      acc.cost += assertNumber(poli.cost);
      acc.quantity += assertNumber(poli.quantity);
      // acc.duties += assertNumber(getDuties(poli));
      acc.received += assertNumber(poli.received);
      return acc;
    },
    {
      quantity: 0,
      cost: 0,
      totalCost: 0,
      duties: 0,
      received: 0,
      receivedCost: 0,
    },
  );

export const getDuties = (variant: { duty_rate?: number; cost?: number }): string => {
  const dutyRate = Number(variant.duty_rate || 0) / 100;
  const cost = Number(variant.cost || 0);
  return (dutyRate * cost).toFixed(2);
};

export const KEYS = {
  FORECASTING_METHOD: 1,
  SAMPLING_PERIOD: 2,
  DAYS_OF_INVENTORY: 3,
  SALES_CHANNEL_IDS: 4,
  INCLUDE_ALL_OUT_OF_STOCK_VARIANTS: 5,
};

export const formatPercent = (percent: number): string =>
  new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(percent);

export const getCostAndMargin = (
  purchaseOrderLineItem: CostAndMarginLineItem,
  exchangeRate?: number,
  showConvertedCost = false,
): CostAndMargin => {
  if (exchangeRate === undefined) {
    return { margin: "" };
  }

  const cost = assertNumber(purchaseOrderLineItem.cost);
  if (cost === 0) {
    return { margin: "" };
  }

  const costForMargin = cost * exchangeRate;
  return {
    convertedCost: showConvertedCost ? costForMargin : undefined,
    margin: formatPercent((assertNumber(purchaseOrderLineItem.price) / costForMargin) - 1),
  };
};
